// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Progress Notes – design system to match reference (light theme, teal buttons, blue accent) */
/* Background: #F8F8F8 | Primary text: #212121 | Secondary: #616161 | Active tab: #1A73E8 | Card button: #00796B | Inactive tab bg: #EFEFEF */

.progress-notes-page {
  min-height: 100vh;
  background: #f8f8f8;
  padding: 24px;
  font-family: 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;
}

/* Report detail page: centered, larger content, no navbar */
.progress-notes-detail-page {
  max-width: 900px;
  margin: 0 auto;
  padding: 32px 40px 48px;
}

.progress-notes-detail-page .progress-notes-member-name {
  font-size: 32px;
}

.progress-notes-detail-page .progress-notes-member-subtitle {
  font-size: 18px;
}

.progress-notes-detail-page .progress-notes-toolbar {
  padding: 24px;
}

.progress-notes-detail-page .progress-notes-section-title {
  font-size: 20px;
}

.progress-notes-detail-page .progress-notes-input,
.progress-notes-detail-page .progress-notes-select {
  font-size: 15px;
  padding: 10px 14px;
}

.progress-notes-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #212121;
  text-decoration: none;
  font-size: 16px;
  margin-bottom: 20px;
  font-weight: 500;
}

.progress-notes-back:hover {
  color: #1a73e8;
}

.progress-notes-title {
  color: #212121;
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 24px 0;
}

/* Member name (detail page – large, like reference profile) */
.progress-notes-member-name {
  color: #212121;
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 8px 0;
}

.progress-notes-member-subtitle {
  color: #616161;
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 20px 0;
}

/* Horizontal tabs (match 2nd image: oval, active blue, inactive grey) */
.progress-notes-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 24px;
}

.progress-notes-tab {
  padding: 10px 20px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  border: none;
  cursor: default;
  background: #efefef;
  color: #616161;
}

.progress-notes-tab.active {
  background: #1a73e8;
  color: #fff;
}

.progress-notes-search-wrap {
  margin-bottom: 24px;
}

.progress-notes-search {
  padding: 10px 14px;
  font-size: 14px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  width: 320px;
  max-width: 100%;
  margin-right: 12px;
  background: #fff;
  color: #212121;
}

.progress-notes-search::placeholder {
  color: #616161;
}

.progress-notes-meta {
  color: #616161;
  font-size: 14px;
}

/* Card grid (member cards) */
.progress-notes-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.progress-notes-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 20px;
  transition: box-shadow 0.2s ease;
}

.progress-notes-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.progress-notes-card-title {
  color: #212121;
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 6px 0;
}

.progress-notes-card-sub {
  color: #616161;
  font-size: 14px;
  margin: 0 0 16px 0;
}

/* Primary action button (teal – Open / View Reports) */
.progress-notes-btn-open {
  display: inline-block;
  padding: 10px 20px;
  background: #00796b;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  transition: background 0.2s ease;
}

.progress-notes-btn-open:hover {
  background: #005a4f;
}

/* Secondary / outline button */
.progress-notes-btn-secondary {
  display: inline-block;
  padding: 8px 16px;
  background: #fff;
  color: #1a73e8;
  border: 1px solid #1a73e8;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease;
}

.progress-notes-btn-secondary:hover {
  background: #e8f0fe;
}

/* Top bar / toolbar (detail screen) */
.progress-notes-toolbar {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 20px;
  margin-bottom: 24px;
}

.progress-notes-toolbar label {
  color: #212121;
  font-weight: 600;
  margin-right: 12px;
}

.progress-notes-toolbar .progress-notes-meta {
  margin-bottom: 12px;
}

/* Form inputs (detail screen) */
.progress-notes-input {
  padding: 8px 12px;
  font-size: 14px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: #fff;
  color: #212121;
}

.progress-notes-input:focus {
  outline: none;
  border-color: #1a73e8;
}

.progress-notes-select {
  padding: 8px 12px;
  font-size: 14px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: #fff;
  color: #212121;
  margin-right: 10px;
}

/* Generate button (teal like Open) */
.progress-notes-btn-primary {
  padding: 10px 20px;
  background: #00796b;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-right: 10px;
  transition: background 0.2s ease;
}

.progress-notes-btn-primary:hover:not(:disabled) {
  background: #005a4f;
}

.progress-notes-btn-primary:disabled {
  background: #bdbdbd;
  cursor: not-allowed;
}

/* Section headings in detail form */
.progress-notes-section-title {
  color: #212121;
  font-size: 18px;
  font-weight: 600;
  margin: 24px 0 12px 0;
}

.progress-notes-field-label {
  color: #616161;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}

.progress-notes-form-group {
  margin-bottom: 16px;
}

.progress-notes-form-group input[type="text"] {
  width: 100%;
  max-width: 600px;
  margin: 4px 0;
}

/* Empty / loading state */
.progress-notes-empty {
  color: #616161;
  font-size: 16px;
  text-align: center;
  padding: 48px 20px;
}

.progress-notes-loading {
  color: #616161;
  font-size: 16px;
  padding: 24px 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/BiWeeklyReport/ProgressNotes.css"],"names":[],"mappings":"AAAA,+FAA+F;AAC/F,6IAA6I;;AAE7I;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,6DAA6D;AAC/D;;AAEA,4DAA4D;AAC5D;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,8DAA8D;AAC9D;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,uDAAuD;AACvD;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB","sourcesContent":["/* Progress Notes – design system to match reference (light theme, teal buttons, blue accent) */\n/* Background: #F8F8F8 | Primary text: #212121 | Secondary: #616161 | Active tab: #1A73E8 | Card button: #00796B | Inactive tab bg: #EFEFEF */\n\n.progress-notes-page {\n  min-height: 100vh;\n  background: #f8f8f8;\n  padding: 24px;\n  font-family: 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;\n}\n\n/* Report detail page: centered, larger content, no navbar */\n.progress-notes-detail-page {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 32px 40px 48px;\n}\n\n.progress-notes-detail-page .progress-notes-member-name {\n  font-size: 32px;\n}\n\n.progress-notes-detail-page .progress-notes-member-subtitle {\n  font-size: 18px;\n}\n\n.progress-notes-detail-page .progress-notes-toolbar {\n  padding: 24px;\n}\n\n.progress-notes-detail-page .progress-notes-section-title {\n  font-size: 20px;\n}\n\n.progress-notes-detail-page .progress-notes-input,\n.progress-notes-detail-page .progress-notes-select {\n  font-size: 15px;\n  padding: 10px 14px;\n}\n\n.progress-notes-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #212121;\n  text-decoration: none;\n  font-size: 16px;\n  margin-bottom: 20px;\n  font-weight: 500;\n}\n\n.progress-notes-back:hover {\n  color: #1a73e8;\n}\n\n.progress-notes-title {\n  color: #212121;\n  font-size: 28px;\n  font-weight: 700;\n  margin: 0 0 24px 0;\n}\n\n/* Member name (detail page – large, like reference profile) */\n.progress-notes-member-name {\n  color: #212121;\n  font-size: 28px;\n  font-weight: 700;\n  margin: 0 0 8px 0;\n}\n\n.progress-notes-member-subtitle {\n  color: #616161;\n  font-size: 16px;\n  font-weight: 500;\n  margin: 0 0 20px 0;\n}\n\n/* Horizontal tabs (match 2nd image: oval, active blue, inactive grey) */\n.progress-notes-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 24px;\n}\n\n.progress-notes-tab {\n  padding: 10px 20px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 500;\n  border: none;\n  cursor: default;\n  background: #efefef;\n  color: #616161;\n}\n\n.progress-notes-tab.active {\n  background: #1a73e8;\n  color: #fff;\n}\n\n.progress-notes-search-wrap {\n  margin-bottom: 24px;\n}\n\n.progress-notes-search {\n  padding: 10px 14px;\n  font-size: 14px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  width: 320px;\n  max-width: 100%;\n  margin-right: 12px;\n  background: #fff;\n  color: #212121;\n}\n\n.progress-notes-search::placeholder {\n  color: #616161;\n}\n\n.progress-notes-meta {\n  color: #616161;\n  font-size: 14px;\n}\n\n/* Card grid (member cards) */\n.progress-notes-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 20px;\n}\n\n.progress-notes-card {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  padding: 20px;\n  transition: box-shadow 0.2s ease;\n}\n\n.progress-notes-card:hover {\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n}\n\n.progress-notes-card-title {\n  color: #212121;\n  font-size: 18px;\n  font-weight: 700;\n  margin: 0 0 6px 0;\n}\n\n.progress-notes-card-sub {\n  color: #616161;\n  font-size: 14px;\n  margin: 0 0 16px 0;\n}\n\n/* Primary action button (teal – Open / View Reports) */\n.progress-notes-btn-open {\n  display: inline-block;\n  padding: 10px 20px;\n  background: #00796b;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  text-decoration: none;\n  transition: background 0.2s ease;\n}\n\n.progress-notes-btn-open:hover {\n  background: #005a4f;\n}\n\n/* Secondary / outline button */\n.progress-notes-btn-secondary {\n  display: inline-block;\n  padding: 8px 16px;\n  background: #fff;\n  color: #1a73e8;\n  border: 1px solid #1a73e8;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  text-decoration: none;\n  transition: all 0.2s ease;\n}\n\n.progress-notes-btn-secondary:hover {\n  background: #e8f0fe;\n}\n\n/* Top bar / toolbar (detail screen) */\n.progress-notes-toolbar {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  padding: 20px;\n  margin-bottom: 24px;\n}\n\n.progress-notes-toolbar label {\n  color: #212121;\n  font-weight: 600;\n  margin-right: 12px;\n}\n\n.progress-notes-toolbar .progress-notes-meta {\n  margin-bottom: 12px;\n}\n\n/* Form inputs (detail screen) */\n.progress-notes-input {\n  padding: 8px 12px;\n  font-size: 14px;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  background: #fff;\n  color: #212121;\n}\n\n.progress-notes-input:focus {\n  outline: none;\n  border-color: #1a73e8;\n}\n\n.progress-notes-select {\n  padding: 8px 12px;\n  font-size: 14px;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  background: #fff;\n  color: #212121;\n  margin-right: 10px;\n}\n\n/* Generate button (teal like Open) */\n.progress-notes-btn-primary {\n  padding: 10px 20px;\n  background: #00796b;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  margin-right: 10px;\n  transition: background 0.2s ease;\n}\n\n.progress-notes-btn-primary:hover:not(:disabled) {\n  background: #005a4f;\n}\n\n.progress-notes-btn-primary:disabled {\n  background: #bdbdbd;\n  cursor: not-allowed;\n}\n\n/* Section headings in detail form */\n.progress-notes-section-title {\n  color: #212121;\n  font-size: 18px;\n  font-weight: 600;\n  margin: 24px 0 12px 0;\n}\n\n.progress-notes-field-label {\n  color: #616161;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 6px;\n}\n\n.progress-notes-form-group {\n  margin-bottom: 16px;\n}\n\n.progress-notes-form-group input[type=\"text\"] {\n  width: 100%;\n  max-width: 600px;\n  margin: 4px 0;\n}\n\n/* Empty / loading state */\n.progress-notes-empty {\n  color: #616161;\n  font-size: 16px;\n  text-align: center;\n  padding: 48px 20px;\n}\n\n.progress-notes-loading {\n  color: #616161;\n  font-size: 16px;\n  padding: 24px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
